import { BaseModel } from "../../../../ensue-react-system/utilities/base-model";
import { FootballSeason } from "../football-season";
import { FootballTeam } from "../football-team";
import { IFootballHostedCompetition } from "../interface/i-football-competition";
import { IFootballSeason } from "../interface/i-football-season";
import { IFootballTeam } from "../interface/i-football-team";
import {
  ICompetitionCreater,
  ICompetitionInvitationResponse,
  IManageFootballCompetitionInvitation,
} from "./interface/i-manage-football-competition-invitation";
import { ManageFootballHostedCompetition } from "./manage-football-hosted-competition";

export class ManageFootballCompetitionInvitation extends BaseModel implements IManageFootballCompetitionInvitation {
  public id: number = 0;
  public status: string = "";
  public competition: IFootballHostedCompetition = new ManageFootballHostedCompetition();
  public season: IFootballSeason = new FootballSeason();
  public selectedTeam: IFootballTeam = new FootballTeam();
  public creator: ICompetitionCreater = new FootballCOmpetitionCreater();
  public invitedResponses: ICompetitionInvitationResponse[] = [];

  public constructor(props: { [key: string]: any } | undefined = undefined) {
    super(props);
    this.__init(props);
  }
}

class FootballCOmpetitionCreater implements ICompetitionCreater {
  public id: number = 0;
  public firstName: string = "";
  public lastName: string = "";
  public middleName: string | null = "";
  public avatar: string | null = "";
  public email: string = "";
  public fullName: string = "";
}
